import { LoginPage } from "@/components/admin/login-page";

/**
 * StartPage - Entry point for unauthenticated users.
 *
 * With SECURITY INVOKER on init_state, we can't reliably check initialization
 * status without a session. Since the app is already set up, we always show
 * the login page for unauthenticated users.
 */
export const StartPage = () => {
  return <LoginPage />;
};
